import { AuthorizationResult } from "@solana-mobile/mobile-wallet-adapter-protocol";
import { AuthorizationResultCache } from "@solana-mobile/wallet-adapter-mobile";

const AUTH_RESULT_KEY = "authorizationResult";
export const authorizationResultCache: AuthorizationResultCache = {
  async clear() {
    localStorage.removeItem(AUTH_RESULT_KEY);
  },
  async get() {
    const storedValue = localStorage.getItem(AUTH_RESULT_KEY);
    if (storedValue) {
      try {
        return JSON.parse(storedValue) as AuthorizationResult;
      } catch (error) {
        console.error("Error parsing authorization result:", error);
        return undefined;
      }
    }
    return undefined;
  },
  async set(authorizationResult: AuthorizationResult) {
    console.log("authorizationResult", authorizationResult);
    localStorage.setItem(AUTH_RESULT_KEY, JSON.stringify(authorizationResult));
  },
};
